export default __webpack_public_path__ + "static/media/ssl.7cbab47f.png";